import React from 'react';
import { Descriptions, Spin, Tag, Typography } from 'antd';
import Drawer from '../../../../components/AppDrawer';
import type { ContactCategoryDetail } from '../types';
import AuditProperties from '../../../../components/AuditProperties';

const { Text } = Typography;

export interface ContactCategoryViewDrawerProps {
  open: boolean;
  onClose: () => void;
  contactCategory: ContactCategoryDetail | null | undefined;
  loading: boolean;
  onEdit: () => void;
}

const ContactCategoryViewDrawer: React.FC<ContactCategoryViewDrawerProps> = ({
  open,
  onClose,
  contactCategory,
  loading,
  onEdit,
}) => {

  return (
    <Drawer
      title="Contact category details"
      placement="right"
      size="large"
      open={open}
      onClose={onClose}
      extra={
        <Typography.Link onClick={onEdit} style={{ marginRight: 8 }}>
          Edit
        </Typography.Link>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      ) : contactCategory === null || contactCategory === undefined ? (
        <Text type="secondary">Category not found.</Text>
      ) : (
        <>
          <div className="cp-form-section">
            <Descriptions column={2} size="small" title="Basic information">
              <Descriptions.Item label="Label" span={2}>
                <Text strong>{contactCategory.label}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Code">{contactCategory.code}</Descriptions.Item>
              <Descriptions.Item label="Sort order">{contactCategory.sortOrder}</Descriptions.Item>
              <Descriptions.Item label="Customer segment" span={2}>
                {contactCategory.customerSegmentTitle}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {contactCategory.isActive ? (
                  <Tag color="green">Active</Tag>
                ) : (
                  <Tag color="default">Inactive</Tag>
                )}
              </Descriptions.Item>
            </Descriptions>
          </div>

          <AuditProperties
            className="cp-form-section"
            values={{
              createdAtUtc: contactCategory.createdAtUtc,
              createdByDisplayName: contactCategory.createdByDisplayName,
              createdByUserId: contactCategory.createdByUserId,
              lastModifiedAtUtc: contactCategory.lastModifiedAtUtc,
              modifiedByDisplayName: contactCategory.modifiedByDisplayName,
              modifiedByUserId: contactCategory.modifiedByUserId,
            }}
          />
        </>
      )}
    </Drawer>
  );
};

export default ContactCategoryViewDrawer;
